export const NATION_TO_ISO = {
  // UK home nations + Ireland
  England: "gb-eng",
  Scotland: "gb-sct",
  Wales: "gb-wls",
  "Northern Ireland": "gb-nir",
  "United Kingdom": "gb",
  "Republic of Ireland": "ie",
  Ireland: "ie",

  // Europe
  France: "fr",
  Germany: "de",
  Spain: "es",
  Italy: "it",
  Netherlands: "nl",
  Portugal: "pt",
  Belgium: "be",
  Sweden: "se",
  Norway: "no",
  Denmark: "dk",
  Finland: "fi",
  Iceland: "is",
  Switzerland: "ch",
  Austria: "at",
  Poland: "pl",
  "Czech Republic": "cz",
  Czechia: "cz",
  Croatia: "hr",
  Serbia: "rs",
  "Bosnia and Herzegovina": "ba",
  "Bosnia Herzegovina": "ba",
  Slovenia: "si",
  Slovakia: "sk",
  Hungary: "hu",
  Romania: "ro",
  Bulgaria: "bg",
  Greece: "gr",
  Turkey: "tr",
  Türkiye: "tr",
  Russia: "ru",
  Ukraine: "ua",
  Belarus: "by",
  Albania: "al",
  "North Macedonia": "mk",
  Macedonia: "mk",
  Kosovo: "xk",
  Montenegro: "me",
  Moldova: "md",
  Estonia: "ee",
  Latvia: "lv",
  Lithuania: "lt",
  Luxembourg: "lu",
  Malta: "mt",
  Cyprus: "cy",
  Georgia: "ge",
  Armenia: "am",
  Azerbaijan: "az",

  // Americas
  Brazil: "br",
  Argentina: "ar",
  Uruguay: "uy",
  Chile: "cl",
  Colombia: "co",
  Mexico: "mx",
  "United States": "us",
  USA: "us",
  Canada: "ca",
  Jamaica: "jm",
  "Costa Rica": "cr",
  Ecuador: "ec",
  Peru: "pe",
  Venezuela: "ve",
  Paraguay: "py",
  Bolivia: "bo",
  Panama: "pa",
  Honduras: "hn",
  "El Salvador": "sv",
  Guatemala: "gt",
  Nicaragua: "ni",
  Cuba: "cu",
  "Dominican Republic": "do",
  Haiti: "ht",
  "Trinidad and Tobago": "tt",
  Curacao: "cw",
  Curaçao: "cw",

  // Africa
  Senegal: "sn",
  "Ivory Coast": "ci",
  "Côte d'Ivoire": "ci",
  "Cote d'Ivoire": "ci",
  Ghana: "gh",
  Nigeria: "ng",
  Cameroon: "cm",
  Egypt: "eg",
  Morocco: "ma",
  Algeria: "dz",
  Tunisia: "tn",
  "South Africa": "za",
  Mali: "ml",
  Guinea: "gn",
  "DR Congo": "cd",
  "Congo DR": "cd",
  "Democratic Republic of the Congo": "cd",
  Congo: "cg",
  "Burkina Faso": "bf",
  Zambia: "zm",
  Zimbabwe: "zw",
  Angola: "ao",
  Mozambique: "mz",
  Kenya: "ke",
  Ethiopia: "et",
  Uganda: "ug",
  Tanzania: "tz",
  "Cape Verde": "cv",
  "Cabo Verde": "cv",
  "Equatorial Guinea": "gq",
  Gabon: "ga",
  Togo: "tg",
  Benin: "bj",
  "Sierra Leone": "sl",
  Liberia: "lr",
  Gambia: "gm",
  Madagascar: "mg",
  Sudan: "sd",
  Libya: "ly",

  // Asia + Oceania
  Japan: "jp",
  "South Korea": "kr",
  "Korea Republic": "kr",
  "North Korea": "kp",
  "Korea DPR": "kp",
  China: "cn",
  "China PR": "cn",
  Australia: "au",
  "New Zealand": "nz",
  Iran: "ir",
  Iraq: "iq",
  "Saudi Arabia": "sa",
  "United Arab Emirates": "ae",
  Qatar: "qa",
  Kuwait: "kw",
  Bahrain: "bh",
  Oman: "om",
  Jordan: "jo",
  Lebanon: "lb",
  Syria: "sy",
  Israel: "il",
  Palestine: "ps",
  Yemen: "ye",
  Afghanistan: "af",
  Pakistan: "pk",
  India: "in",
  Bangladesh: "bd",
  "Sri Lanka": "lk",
  Nepal: "np",
  Thailand: "th",
  Vietnam: "vn",
  Indonesia: "id",
  Malaysia: "my",
  Singapore: "sg",
  Philippines: "ph",
  Myanmar: "mm",
  Cambodia: "kh",
  Laos: "la",
  "Hong Kong": "hk",
  Taiwan: "tw",
  "Chinese Taipei": "tw",
  Kazakhstan: "kz",
  Uzbekistan: "uz",
  Kyrgyzstan: "kg",
  Tajikistan: "tj",
  Turkmenistan: "tm",
  Mongolia: "mn",
};
